import { useAuth } from '@/hooks/useAuth';
import { useQueryUser } from '@heidi/workspace/data';

/** Never arbitrate against the previous account while auth/user queries switch. */
export const useBannerIdentity = (): string | undefined => {
  const auth = useAuth();
  const { data: user } = useQueryUser((user) => ({
    userRefId: user.user_ref_id,
    kindeUserId: user.kinde_user_id,
  }));
  return !auth.isLoading &&
    auth.isAuthenticated &&
    auth.user?.id &&
    (auth.user.id === user?.userRefId || auth.user.id === user?.kindeUserId)
    ? user?.userRefId
    : undefined;
};
